import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from "@angular/core";
import {ResponseType} from "../../utils/enums";

@Component({
  selector: "app-survey-radio-group",
  templateUrl: "./survey-radio-group.component.html",
  styleUrls: ["./survey-radio-group.component.scss"],
  standalone: false
})
export class SurveyRadioGroupComponent implements OnChanges, OnInit {
  @Input() questionDetails: any;
  @Output() answerSelectedEvent = new EventEmitter<any>();

  questionAnswerMap: any = {};
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
  }

  answerSelected(answer: any): void {
    this.questionAnswerMap = this.questionDetails.SelectedAnswer?.Answers || {}
    this.questionAnswerMap[answer.QuestionId] = answer;
    this.answerSelectedEvent.emit(this.convertToSurveyAnswer());
  }

  convertToSurveyAnswer(): any {
    const surveyAnswer: any = {
      Answers: this.questionAnswerMap,
      Action: this.questionDetails.Action,
      ResponseType: ResponseType.MultiQuestionRadioGroup
    };

    return surveyAnswer;
  }
}
